export function isGuid(str:string) {
  const regex = new RegExp(
    /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/
  );
  return regex.test(str);
}
